module.exports = __webpack_public_path__ + "img/Music.ba5a5e96.jpg";